/**
 * @fileoverview added by tsickle
 * Generated from: models/worker-mood-sample.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { model } from '../util/model';
/**
 * @record
 */
export function WorkerSampleCampaign() { }
if (false) {
    /** @type {?} */
    WorkerSampleCampaign.prototype.question;
    /** @type {?|undefined} */
    WorkerSampleCampaign.prototype.title;
    /** @type {?|undefined} */
    WorkerSampleCampaign.prototype.positiveIcon;
    /** @type {?|undefined} */
    WorkerSampleCampaign.prototype.negativeIcon;
    /** @type {?|undefined} */
    WorkerSampleCampaign.prototype.positiveAnswer;
    /** @type {?|undefined} */
    WorkerSampleCampaign.prototype.negativeAnswer;
}
/**
 * @record
 */
export function MoodSampleCampaign() { }
/**
 * @record
 */
export function InterventionSampleCampaign() { }
/** @type {?} */
export var moodSampleCampaign = model.extend({
    modelName: 'moodSampleCampaign'
});
/** @type {?} */
export var interventionSampleCampaign = model.extend({
    modelName: 'interventionSampleCampaign'
});
/** @enum {string} */
var WorkerMood = {
    None: "",
    Good: "good",
    Bad: "bad",
    Dismissed: "dismissed",
};
export { WorkerMood };
/**
 * @record
 */
export function WorkerMoodSample() { }
if (false) {
    /** @type {?} */
    WorkerMoodSample.prototype.mood;
    /** @type {?} */
    WorkerMoodSample.prototype.sampledAt;
    /** @type {?|undefined} */
    WorkerMoodSample.prototype.campaign;
}
/** @type {?} */
export var workerMoodSample = model.extend({
    modelName: 'workerMoodSample'
});
/** @enum {string} */
var WorkerInterventionResponse = {
    None: "",
    Yes: "yes",
    No: "no",
    Dismissed: "dismissed",
};
export { WorkerInterventionResponse };
/**
 * @record
 */
export function WorkerInterventionSample() { }
if (false) {
    /** @type {?} */
    WorkerInterventionSample.prototype.response;
    /** @type {?} */
    WorkerInterventionSample.prototype.sampledAt;
    /** @type {?|undefined} */
    WorkerInterventionSample.prototype.campaign;
}
/** @type {?} */
export var workerInterventionSample = model.extend({
    modelName: 'workerInterventionSample'
});
